import BrandHeroBlock from '@/blocks/BrandHeroBlock';
import BreadcrumbsBlock from '@/blocks/BreadcrumbsBlock';
import DeliveredProjectsBlock from '@/blocks/DeliveredProjectsBlock';
import TextImageAsideBlock from '@/blocks/TextImageAsideBlock';
import TextImageAsideDarkBlock from '@/blocks/TextImageAsideDarkBlock';
import CheckList from '@/components/CheckList';
import { MEDIA_URL, REVALIDATE_TIME_IN_SEC } from '@/constants/env';
import { pages } from '@/content';
import { filterByCompany } from '@/hooks/project';
import FullWidthLayout from '@/layouts/FullWidthLayout';
import graphql from '@/lib/graphql';
import mainLayout from '@/graphql/queries/mainLayout';
import Markdown from 'react-markdown';
import page from '@/graphql/queries/page';

export default function ConstructionPage({ mainLayout, page }) {
  const attributes = page?.attributes || {};
  const contentSection = attributes.contentSection || [];
  const metaData = attributes.metaData || {};
  return (
    <FullWidthLayout mainLayout={mainLayout} metaData={metaData}>
      {contentSection[0]?.heroImage?.data?.attributes?.url ? (
        <BrandHeroBlock
          image={MEDIA_URL.concat(contentSection[0].heroImage.data.attributes.url)}
          title={contentSection[0].heroTitle}
        />
      ) : null}
      <BreadcrumbsBlock items={[pages.home, pages.construction]} />
      {contentSection[1]?.textImageAsideImage?.data?.attributes?.url ? (
        <TextImageAsideBlock
          image={MEDIA_URL.concat(contentSection[1].textImageAsideImage.data.attributes.url)}
          imageClassName="lg:aspect-square"
          imageDirection="right"
          subtitle={contentSection[1].textImageAsideSubtitle}
          title={contentSection[1].textImageAsideTitle}
        >
          <Markdown>{contentSection[1].textImageAsideText}</Markdown>
        </TextImageAsideBlock>
      ) : null}
      {contentSection[2]?.textImageADarkImage?.data?.attributes?.url ? (
        <TextImageAsideDarkBlock
          image={MEDIA_URL.concat(contentSection[2].textImageADarkImage.data.attributes.url)}
          subtitle={contentSection[2].subtitle}
          title={contentSection[2].textImageADarkTitle}
        >
          <p className="text-xl">{contentSection[2].description}</p>
          <CheckList iconColor="text-white" items={contentSection[2].list || []} />
        </TextImageAsideDarkBlock>
      ) : null}
      {contentSection[3] ? <DeliveredProjectsBlock projects={contentSection[3]} /> : null}
    </FullWidthLayout>
  );
}

export async function getStaticProps() {
  try {
    const { data: mainLayoutData } = await graphql(mainLayout);
    const { data: pageData } = await graphql(page, { slug: 'construction' });

    return {
      props: {
        mainLayout: mainLayoutData?.mainLayout?.data || { attributes: {} },
        page: (pageData?.pages?.data || [])[0] || { attributes: {} },
      },
      revalidate: parseInt(REVALIDATE_TIME_IN_SEC) || 60, // In seconds
    };
  } catch (_err) {
    return {
      props: {
        mainLayout: { attributes: {} },
        page: { attributes: {} },
      },
      revalidate: parseInt(REVALIDATE_TIME_IN_SEC) || 60,
    };
  }
}
